import { FC } from 'react';
import { Badge, IconButton, IconButtonSizes, IconButtonStyles, Icons, Tooltip } from '@silverfort/sf-components';
import { PreviewItem } from '../types';

interface DataRowsProps {
    data: PreviewItem[];
    onInvestigateClick: (guid: string) => void;
}

const DataRows: FC<DataRowsProps> = ({ data, onInvestigateClick }) => (
    <div className="flex flex-col gap-2 w-full max-h-[232px] overflow-y-auto">
        {data.map((item) => (
            <div
                key={item.guid}
                className="flex-1 rounded-lg h-10 p-2 pl-4 flex flex-row justify-between items-center bg-sf-gray-0 group hover:bg-sf-gray-50">
                <div className="flex flex-row items-center gap-2">
                    <div className="w-30 text-13 group-hover:underline">{item.name}</div>
                    <IconButton
                        className="opacity-0 group-hover:opacity-100 text-sf-gray-400"
                        sizeVariant={IconButtonSizes.Large}
                        buttonStyle={IconButtonStyles.Secondary}
                        iconSize={16}
                        icon={Icons.Investigate}
                        onClick={() => onInvestigateClick(item.guid)}
                    />
                    {item.badgeProps && <Badge {...item.badgeProps} />}
                </div>
                <div className="text-12 bg-sf-white border border-sf-gray-100 rounded-[4px] px-2">
                    <Tooltip placement='top' title='Hits'>
                        <>{item.hits.toLocaleString()}</>
                    </Tooltip>
                </div>
            </div>
        ))}
    </div>
);

export default DataRows;
